module.exports = __webpack_public_path__ + "triangle-right.svg?c077cc4b0fe63c84cfaf0ff441077fb0";